import React, { useState, useEffect } from "react";
import ACpricingConfig from "./pricingConfig";
import ACpricingConfigDelhi from "./pricingConfigDelhi";

export default function ACdetails({
  setShowSavedItems,
  showSavedItems,
  onACDetailsChange,
  savedItems,
  setSavedItems,
  acDetails,
  setACDetails,
  take3MonthPayment,
  setTake3MonthPayment,
}) {
  // console.log({ acDetails: savedItems });
  const [modalACDetails, setModalACDetails] = useState(false);
  const [editModalACDetails, setEditModalACDetails] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  let user = localStorage.getItem("userName");
  let state = localStorage.getItem("state");
  const editableUsers = [
    "Karishma",
    "Deepak Undariwal",
    "Sales Admin",
    "Noorbi Shaikh",
    "Ashish A (Delhi)",
    "Vineet Vidyanand",
    "Gajanan Padhar",
  ];
  const isEditableUser = editableUsers.includes(user);
  useEffect(() => {
    updateHandler();
  }, [acDetails.quantity]);
  useEffect(() => {
    if (isEditMode) {
      setIsEditMode(false);
      return;
    }
    updatePricing();
  }, [acDetails.plan, acDetails.ton, acDetails.acType]);

  const handleEdit = (item) => {
    setIsEditMode(true);
    setACDetails(item);
    onACDetailsChange(item);
    setModalACDetails(true);
    setEditModalACDetails(true);
  };
  const currentState = localStorage.getItem("state") || "Maharashtra";

  const updatePricing = () => {
    let { acType, ton, plan } = acDetails;
    const quantity = 1; // Default quantity for pricing calculation
    const pricingDetails =
      currentState === "Delhi"
        ? ACpricingConfigDelhi[acType]?.[ton]?.[plan]
        : ACpricingConfig[acType]?.[ton]?.[plan];
    if (!pricingDetails) {
      console.error("Invalid configuration for AC type, ton, or plan");
      return;
    }
    const {
      subscription,
      priceAfter3Years,
      installetionCharge,
      depositamount,
    } = pricingDetails;

    const totalSubscription = subscription * quantity;
    const totalDeposit = depositamount * quantity;
    const totalInstallation = installetionCharge * quantity;
    const totalAfter3Years = priceAfter3Years * quantity;
    const totalAmount = totalSubscription + totalDeposit + totalInstallation;
    const itemId = `mc_${plan === "5years" ? "5" : "3+2"}y_${ton.replace(
      " ",
      "_"
    )}`;
    //console.log({ ...acDetails }, "checkfirst");
    const updatedDetails = {
      ...acDetails,
      subscription_plan: subscription,
      depositamount: depositamount,
      installetionCharge: installetionCharge,
      itemId: itemId,
      totalSubscription: totalSubscription,
      totalDeposit: totalDeposit,
      totalInstallation: totalInstallation,
      priceAfter3Years: priceAfter3Years,
      totalAfter3Years: totalAfter3Years,
      totalAmount: totalAmount,
    };
    //console.log(updatedDetails, "checktwo");
    setACDetails(updatedDetails);
    onACDetailsChange(updatedDetails);
  };

  const updateHandler = () => {
    const totalSubscription =
      parseInt(acDetails.subscription_plan) * parseInt(acDetails.quantity);
    const totalDeposit =
      parseInt(acDetails.depositamount) * parseInt(acDetails.quantity);
    const totalInstallation =
      parseInt(acDetails.installetionCharge) * parseInt(acDetails.quantity);
    const totalAfter3Years =
      parseInt(acDetails.priceAfter3Years) * parseInt(acDetails.quantity);

    const totalAmount = totalSubscription + totalDeposit + totalInstallation;

    const updatedDetails = {
      ...acDetails,
      totalSubscription: totalSubscription,
      totalDeposit: totalDeposit,
      totalInstallation: totalInstallation,
      totalAfter3Years: totalAfter3Years,
      totalAmount: totalAmount,
    };
    setACDetails(updatedDetails);
    onACDetailsChange(updatedDetails);
  };

  const handleBlur1 = (e) => {
    const { id, value } = e.target;
    let newValue = value === "" ? null : Number(value);
    const acType = acDetails.acType;

    // 🚨 Apply validation for everyone except "Karishma" and "Gajanan Padhar"
    if (
      id === "installetionCharge" &&
      user !== "Karishma" &&
      user !== "Gajanan Padhar"
    ) {
      // If AC type is Split, check if the value is at least 1500
      if (acType === "Split" && newValue < 1500) {
        alert(
          `The installation charge for Split AC should be more than 1500. Current value: ${newValue}`
        );
        setACDetails((prev) => ({
          ...prev,
          installetionCharge: 1500,
          totalInstallation: 1500 * prev.quantity,
          totalAmount:
            prev.totalSubscription + prev.totalDeposit + 1500 * prev.quantity,
        }));
        return;
      }
      // If AC type is Cassette, check if the value is at least 3500
      else if (acType === "Cassette" && newValue < 3500) {
        alert(
          `The installation charge for Cassette AC should be at least 3500. Current value: ${newValue}`
        );
        setACDetails((prev) => ({
          ...prev,
          installetionCharge: 3500,
          totalInstallation: 3500 * prev.quantity,
          totalAmount:
            prev.totalSubscription + prev.totalDeposit + 3500 * prev.quantity,
        }));
        return;
      }
    }

    // ✅ If validation passes (or user is exempt), just update
    setACDetails((prev) => ({
      ...prev,
      installetionCharge: newValue,
    }));

    updateHandler();
  };

  const handleBlur2 = (e) => {
    const { id, value } = e.target;
    let newValue = value === "" ? null : Number(value);
    if (id === "depositamount") {
      const acType = acDetails.acType;
      if (isEditableUser) {
        if (acType === "Split" || acType === "Cassette") {
          if (newValue < 3000) {
            alert(
              `The depositamount charge for Split AC should be morethan 3000 . Current value: ${newValue}`
            );
            setACDetails((prevDetails) => ({
              ...prevDetails,
              depositamount: 3000,
              totalDeposit: 3000 * prevDetails.quantity,
              totalAmount:
                prevDetails.totalSubscription +
                prevDetails.totalInstallation +
                3000 * prevDetails.quantity,
            }));
            return;
          }
        }
      } else {
        // If AC type is Split, check if the value is in the range 1500-1800
        if (acType === "Split") {
          if (newValue < 6000) {
            alert(
              `The depositamount charge for Split AC should be morethan 6000 . Current value: ${newValue}`
            );
            setACDetails((prevDetails) => ({
              ...prevDetails,
              depositamount: 6000,
              totalDeposit: 6000 * prevDetails.quantity,
              totalAmount:
                prevDetails.totalSubscription +
                prevDetails.totalInstallation +
                6000 * prevDetails.quantity,
            }));
            return;
          }
        } else if (acType === "Cassette") {
          if (newValue < 15000) {
            alert(
              `The depositamount charge for Cassette AC should be morethan 15000 . Current value: ${newValue}`
            );
            setACDetails((prevDetails) => ({
              ...prevDetails,
              depositamount: 15000,
              totalDeposit: 15000 * prevDetails.quantity,
              totalAmount:
                prevDetails.totalSubscription +
                prevDetails.totalInstallation +
                15000 * prevDetails.quantity,
            }));
            return;
          }
        }
      }
      setACDetails((prevDetails) => ({
        ...prevDetails,
        depositamount: newValue,
      }));

      updateHandler();
    }
  };

  const handleBlur3 = (e) => {
    const { id, value } = e.target;
    let newValue = value === "" ? null : Number(value);

    // Destructure required details from acDetails
    const { acType, ton, plan } = acDetails;

    if (id === "subscription_plan") {
      // Fetch the predefined subscription value from ACpricingConfig
      const predefinedSubscription =
        ACpricingConfig[acType]?.[ton]?.[plan]?.subscription;

      if (predefinedSubscription === undefined) {
        console.error("Invalid configuration for AC type, ton, or plan.");
        return;
      }
      if (isEditableUser) {
        // Check if the entered value is less than the predefined value
        if (newValue < 700) {
          alert(`Subscription plan value cannot be less than 900.`);
          // Reset the value to the minimum allowed
          newValue = 700;
          console.log({ acDetails });
          setACDetails((prevDetails) => ({
            ...prevDetails,
            subscription_plan: 700,
            totalSubscription: 700 * prevDetails.quantity,
            totalAmount:
              prevDetails.totalInstallation +
              prevDetails.totalDeposit +
              700 * prevDetails.quantity,
          }));

          return;
        }
      } else {
        // Check if the entered value is less than the predefined value
        if (newValue < predefinedSubscription) {
          alert(
            `Subscription plan value cannot be less than ${predefinedSubscription}.`
          );
          // Reset the value to the minimum allowed
          // newValue = predefinedSubscription;
          setACDetails((prevDetails) => ({
            ...prevDetails,
            subscription_plan: predefinedSubscription,
            totalSubscription: predefinedSubscription * prevDetails.quantity,
            totalAmount:
              prevDetails.totalInstallation +
              prevDetails.totalDeposit +
              predefinedSubscription * prevDetails.quantity,
          }));

          return;
        }
      }

      // Update the subscription plan with the validated value
      setACDetails((prevDetails) => ({
        ...prevDetails,
        subscription_plan: newValue,
      }));

      // Update the subscription plan with the validated value
      updateHandler();
    }
  };

  const handleBlur4 = (e) => {
    const { id, value } = e.target;
    let newValue = value === "" ? null : Number(value);

    // Destructure required details from acDetails
    const { acType, ton, plan } = acDetails;

    if (id === "priceAfter3Years") {
      // Fetch the predefined subscription value from ACpricingConfig
      const predefinedSubscription =
        ACpricingConfig[acType]?.[ton]?.[plan]?.priceAfter3Years;

      if (predefinedSubscription === undefined) {
        console.error("Invalid configuration for AC type, ton, or plan.");
        return;
      }
      if (isEditableUser) {
        // Check if the entered value is less than the predefined value
        if (newValue < 500) {
          alert(`Subscription plan value cannot be less than 500.`);
          // Reset the value to the minimum allowed
          newValue = 500;
          // console.log({ acDetails });
          setACDetails((prevDetails) => ({
            ...prevDetails,
            priceAfter3Years: 500,
            totalAfter3Years: 500 * prevDetails.quantity,
          }));

          return;
        }
      } else {
        // Check if the entered value is less than the predefined value
        if (newValue < predefinedSubscription) {
          alert(
            `Subscription plan value cannot be less than ${predefinedSubscription}.`
          );
          // Reset the value to the minimum allowed
          // newValue = predefinedSubscription;
          setACDetails((prevDetails) => ({
            ...prevDetails,
            priceAfter3Years: predefinedSubscription,
            totalAfter3Years: predefinedSubscription * prevDetails.quantity,
          }));

          return;
        }
      }

      // Update the subscription plan with the validated value
      setACDetails((prevDetails) => ({
        ...prevDetails,
        priceAfter3Years: newValue,
      }));

      // Update the subscription plan with the validated value
      updateHandler();
    }
  };

  // const handleChange = (e) => {
  //   console.log("In handlechange")
  //   const { id, value } = e.target;
  //   let newValue = value;

  //   switch (id) {
  //     case "quantity":
  //       // Allow the input to be empty or only valid numbers
  //       if (newValue === "" || /^[0-9\b]+$/.test(newValue)) {
  //         newValue = newValue === "" ? null : parseInt(newValue, 10);
  //       }
  //       break;

  //     case "discountamount":
  //     case "discountpercent":
  //       newValue = value === "" ? null : parseFloat(value);
  //       break;

  //     case "acType":
  //       newValue = value;

  //       // Determine the appropriate installation charge based on the AC type
  //       let newInstalletionCharge;
  //       if (isEditableUser) {
  //         if (value === "Split" || value === "Cassette") {
  //           newInstalletionCharge = acDetails.installetionCharge;
  //         }
  //       } else {
  //         if (value === "Split") {
  //           newInstalletionCharge =
  //             acDetails.installetionCharge < 1500 ||
  //             acDetails.installetionCharge == null
  //               ? 1800 // Default to minimum if out of range or null
  //               : acDetails.installetionCharge; // Keep current value if valid
  //         } else if (value === "Cassette") {
  //           newInstalletionCharge =
  //             acDetails.installetionCharge < 3500 ||
  //             acDetails.installetionCharge == null
  //               ? 4000 // Default to minimum if out of range or null
  //               : acDetails.installetionCharge; // Keep current value if valid
  //         } else {
  //           newInstalletionCharge = acDetails.installetionCharge || 1500; // Default to 1500 if other types
  //         }
  //       }

  //       setACDetails((prevDetails) => ({
  //         ...prevDetails,
  //         [id]: newValue, // Update acType
  //         ton: value === "Split" ? "10" : "20", // Update ton based on acType
  //         plan: value === "Cassette" ? "3+3year" : "3+2year", // Update plan based on acType
  //         installetionCharge: newInstalletionCharge, // Set installation charge based on acType
  //       }));
  //       return; // Directly return here to avoid setting the state again later

  //     case "installetionCharge":
  //       newValue = value === "" ? null : Number(value);
  //       break;

  //     default:
  //       break;
  //   }

  //   // Set state with the validated new value
  //   setACDetails((prevDetails) => ({
  //     ...prevDetails,
  //     [id]: newValue,
  //   }));
  // };

  const handleChange = (e) => {
    const { id, value } = e.target;
    let newValue = value;
    const state = localStorage.getItem("state")?.toLowerCase() || "";

    switch (id) {
      case "quantity":
        if (newValue === "" || /^[0-9\b]+$/.test(newValue)) {
          newValue = newValue === "" ? null : parseInt(newValue, 10);
        }
        break;

      case "discountamount":
      case "discountpercent":
        newValue = value === "" ? null : parseFloat(value);
        break;

      case "acType":
        newValue = value;

        // Determine installation charge
        let newInstalletionCharge;
        if (isEditableUser) {
          if (value === "Split" || value === "Cassette") {
            newInstalletionCharge = acDetails.installetionCharge;
          }
        } else {
          newInstalletionCharge = acDetails.installetionCharge || 1500;
        }

        // Set default ton and plan based on state
        const newTon = value === "Split" ? "10" : "20";
        const newPlan = state === "delhi" ? "3+3year" : "3+2year";

        setACDetails((prevDetails) => ({
          ...prevDetails,
          [id]: newValue, // acType
          ton: newTon,
          plan: newPlan,
          installetionCharge: newInstalletionCharge,
        }));
        return;

      case "installetionCharge":
        newValue = value === "" ? null : Number(value);
        break;

      default:
        break;
    }

    setACDetails((prevDetails) => ({
      ...prevDetails,
      [id]: newValue,
    }));
  };

  const handleBlur = () => {
    // Ensure the quantity is at least 1 on blur
    if (acDetails.quantity === null || acDetails.quantity <= 0) {
      setACDetails((prevDetails) => ({
        ...prevDetails,
        quantity: 1, // Set to 1 if empty or less than 1
      }));
    }
  };

  const handleSaveEdit = () => {
    // Update the savedItems array with the edited item
    const updatedItems = savedItems.map((item) =>
      item.id === acDetails.id ? { ...acDetails } : item
    );

    setSavedItems(updatedItems); // Update the saved items state

    // Close the modal and reset the AC details
    setModalACDetails(false);
    setEditModalACDetails(false);
    if (state != "Delhi") {
      setACDetails({
        acType: "Split",
        ton: "10",
        plan: "3+2year",
        quantity: 1,
        subscription_plan: 1328,
        depositamount: 6000,
        installetionCharge: 1770,
        totalSubscription: 1328,
        totalDeposit: 6000,
        totalInstallation: 1770,
        priceAfter3Years: 856,
        totalAfter3Years: 856,
        totalAmount: 9098,
      });
    } else {
      setACDetails({
        acType: "Split",
        ton: "10",
        plan: "3+3year",
        quantity: 1,
        subscription_plan: 1564,
        depositamount: 6000,
        installetionCharge: 1770,
        totalSubscription: 1564,
        totalDeposit: 6000,
        totalInstallation: 1770,
        priceAfter3Years: 1092,
        totalAfter3Years: 1092,
        totalAmount: 9334,
      });
    }
  };

  const handleSave = () => {
    updateHandler();
    const newSavedItems = [...savedItems, { ...acDetails, id: Date.now() }];

    if (acDetails.id) {
      // If editing an existing item, update the savedItems array
      const updatedItems = savedItems.map((item) =>
        item.id === acDetails.id ? { ...acDetails } : item
      );
      setSavedItems(updatedItems);
    } else {
      // If it's a new item, add it to the list
      const newSavedItems = [...savedItems, { ...acDetails, id: Date.now() }];
      setSavedItems(newSavedItems);
    }

    setShowSavedItems(true);
    setModalACDetails(false);
    if (user != "Karishma") {
      if (acDetails.acType === "Split" && acDetails.installetionCharge < 1200) {
        alert("check you have Enter wrong Split Ac installtion charge");
        return;
      }
      if (acDetails.depositamount < 5000) {
        alert("check you have Enter wrong Split Ac deposite amount");
        return;
      }
      if (
        acDetails.acType == "Cassette" &&
        acDetails.installetionCharge < 3500
      ) {
        alert("check you have Enter wrong Cassette Ac installtion charge");
        return;
      }
    }
    setSavedItems(newSavedItems);
    setShowSavedItems(true);
    setModalACDetails(false);
    if (state != "Delhi") {
      setACDetails({
        acType: "Split",
        ton: "10",
        plan: "3+2year",
        quantity: 1,
        subscription_plan: 1328,
        depositamount: 6000,
        installetionCharge: 1770,
        totalSubscription: 1328,
        totalDeposit: 6000,
        totalInstallation: 1770,
        priceAfter3Years: 856,
        totalAfter3Years: 856,
        totalAmount: 9098,
      });
      onACDetailsChange({
        acType: "Split",
        ton: "10",
        plan: "3+2year",
        quantity: 1,
        subscription_plan: 1328,
        depositamount: 6000,
        installetionCharge: 1770,
        totalSubscription: 1328,
        totalDeposit: 6000,
        totalInstallation: 1770,
        priceAfter3Years: 856,
        totalAfter3Years: 856,
        totalAmount: 9098,
      });
    } else {
      setACDetails({
        acType: "Split",
        ton: "10",
        plan: "3+3year",
        quantity: 1,
        subscription_plan: 1564,
        depositamount: 6000,
        installetionCharge: 1770,
        totalSubscription: 1564,
        totalDeposit: 6000,
        totalInstallation: 1770,
        priceAfter3Years: 1092,
        totalAfter3Years: 1092,
        totalAmount: 9334,
      });
      onACDetailsChange({
        acType: "Split",
        ton: "10",
        plan: "3+3year",
        quantity: 1,
        subscription_plan: 1564,
        depositamount: 6000,
        installetionCharge: 1770,
        totalSubscription: 1564,
        totalDeposit: 6000,
        totalInstallation: 1770,
        priceAfter3Years: 1092,
        totalAfter3Years: 1092,
        totalAmount: 9334,
      });
    }
    window.scrollTo(0, 0);
  };

  const handleRemove = (id) => {
    const updatedItems = savedItems.filter((item) => item.id !== id);
    setSavedItems(updatedItems);
  };

  const availableTons =
    acDetails.acType === "Split"
      ? [
          { value: "10", label: "1.0-6.25 ISEER" },
          { value: "15", label: "1.5" },
          { value: "20", label: "2.0" },
        ]
      : [
          { value: "20", label: "2.0" },
          { value: "30", label: "3.0" },
        ];

  // const availablePlans =
  //   state?.toLowerCase() === "delhi"
  //     ? [{ value: "3+3year", label: "3+3 Year" }]
  //     : acDetails.acType === "Cassette"
  //     ? [
  //         { value: "3+2year", label: "3+2 Year" },
  //         { value: "5years", label: "5 Year" },
  //       ]
  //     : acDetails.acType === "Split"
  //     ? acDetails.ton === "15" ||
  //       acDetails.ton === "20" ||
  //       acDetails.ton === "10"
  //       ? [
  //           { value: "3+2year", label: "3+2 Year" },
  //           { value: "5years", label: "5 Year" },
  //         ] // Show both plans for 10, 15, or 20 ton
  //       : [{ value: "3+2year", label: "3+2 Year" }] // Only show 3+2 Year for other tons
  //     : [
  //         { value: "5years", label: "5 Year" },
  //         { value: "3+2year", label: "3+2 Year" },
  //       ];

  const availablePlans =
    state?.toLowerCase() === "delhi"
      ? acDetails.acType === "Cassette" &&
        (acDetails.ton === "20" || acDetails.ton === "30")
        ? [
            { value: "3+2year", label: "3+2 Year" },
            { value: "3+3year", label: "3+3 Year" },
          ]
        : acDetails.acType === "Split" &&
          (acDetails.ton === "10" ||
            acDetails.ton === "15" ||
            acDetails.ton === "20")
        ? [
            { value: "3+2year", label: "3+2 Year" },
            { value: "3+3year", label: "3+3 Year" },
          ]
        : [
            { value: "3+2year", label: "3+2 Year" },
            { value: "3+3year", label: "3+3 Year" },
          ]
      : acDetails.acType === "Cassette"
      ? [
          { value: "3+2year", label: "3+2 Year" },
          { value: "5years", label: "5 Year" },
        ]
      : acDetails.acType === "Split" &&
        (acDetails.ton === "10" ||
          acDetails.ton === "15" ||
          acDetails.ton === "20")
      ? [
          { value: "3+2year", label: "3+2 Year" },
          { value: "5years", label: "5 Year" },
        ]
      : [{ value: "3+2year", label: "3+2 Year" }];

  return (
    <div className="bg-white shadow-md rounded-xl border-2 p-6">
      <h1 className="font-semibold text-lg">
        AC Details <span style={{ color: "red" }}>*</span>
      </h1>
      <p className="text-sm text-red-600 mt-2">
        <strong>Note:</strong> Installation price: Standard for 3+ units; for 3
        or fewer units, addition of INR 25 to Split and INR 50 to Cassette.
      </p>
      {savedItems.length > 0 && (
        <>
          <div className="flex flex-wrap gap-6 mt-4">
            {savedItems.map((item) => (
              <div
                key={item.id}
                className="border border-primary rounded-xl shadow-sm p-5 w-full sm:w-[48%] md:w-[31%] xl:w-[23%] bg-white flex flex-col justify-between"
              >
                <div className="space-y-1 text-sm">
                  <h3 className="text-base font-semibold text-gray-800">
                    {item.acType} AC –{" "}
                    {item.ton === "10"
                      ? "1"
                      : item.ton === "15"
                      ? "1.5"
                      : item.ton === "20"
                      ? "2"
                      : item.ton === "30"
                      ? "3.0"
                      : item.ton}{" "}
                    Ton
                  </h3>
                  <p>
                    Plan: <strong>{item.plan}</strong>
                  </p>
                  <p>Quantity: {item.quantity}</p>
                  <p>Total Installation: ₹{item.totalInstallation}</p>
                  <p>
                    {" "}
                    Subscription (
                    {item.plan === "5years"
                      ? "M1–M60"
                      : item.plan === "6years"
                      ? "M1–M72"
                      : "M1–M36"}
                    ): ₹{item.totalSubscription}
                  </p>
                  <p>Refundable Deposit: ₹{item.totalDeposit}</p>
                  {(item.plan === "3+2year" || item.plan === "3+3year") && (
                    <>
                      <p>
                        {`Subscription ${
                          state === "Delhi" ? "(M37–M72)" : "(M37–M60)"
                        }: ₹`}
                        {item.totalAfter3Years / item.quantity}
                      </p>
                      <p>Total After 3 Years: ₹{item.totalAfter3Years}</p>
                    </>
                  )}
                  <p className="mt-2 font-bold text-primary">
                    Total Amount: ₹{item.totalAmount}
                  </p>
                  {take3MonthPayment && (
                    <>
                      <p>
                        + 3 Month Advance (₹{item.subscription_plan} × 3): ₹
                        {item.subscription_plan * 3}
                      </p>
                      <p className="mt-2 font-bold text-primary">
                        Total with 3 Month Advance: ₹
                        {item.totalAmount + item.subscription_plan * 2}
                      </p>
                    </>
                  )}
                </div>
                <div className="flex justify-between gap-3 mt-4">
                  <button
                    onClick={() => handleRemove(item.id)}
                    className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600 text-sm"
                  >
                    Remove
                  </button>
                  <button
                    onClick={() => handleEdit(item)}
                    className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600 text-sm"
                  >
                    Edit
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* Take 3 Month Advance Payment checkbox */}

          <div className="mt-6">
            <label className="flex items-center gap-2 cursor-pointer text-sm font-medium text-gray-800">
              <span className="relative w-5 h-5">
                <input
                  type="checkbox"
                  checked={take3MonthPayment}
                  onChange={() => setTake3MonthPayment(!take3MonthPayment)}
                  className="w-5 h-5 appearance-none border-2 border-primary rounded-sm
            checked:bg-transparent transition duration-200"
                />
                {take3MonthPayment && (
                  <svg
                    className="absolute inset-0 m-auto w-4 h-4 text-primary pointer-events-none"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                )}
              </span>
              Take 3 Month Advance Payment
            </label>
          </div>
        </>
      )}

      {!modalACDetails && (
        <button
          className="mt-6 border border-primary py-2 px-4 text-primary rounded-lg hover:text-white hover:bg-primary"
          onClick={() => setModalACDetails(true)}
        >
          + Add an AC
        </button>
      )}
      {modalACDetails && (
        <div className="mt-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
            <div>
              <label htmlFor="acType" className="block font-semibold mb-2">
                AC type:
              </label>
              <select
                id="acType"
                className="w-full border-2 border-gray-300 rounded py-2 px-4"
                value={acDetails.acType}
                onChange={handleChange}
              >
                <option value="Split">Split</option>
                <option value="Cassette">Cassette</option>
              </select>
            </div>
            <div>
              <label htmlFor="ton" className="block font-semibold mb-2">
                Ton:
              </label>
              <select
                id="ton"
                className="w-full border-2 border-gray-300 rounded py-2 px-4"
                value={acDetails.ton}
                onChange={handleChange}
              >
                {availableTons.map((ton) => (
                  <option key={ton.value} value={ton.value}>
                    {ton.label}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label htmlFor="plan" className="block font-semibold mb-2">
                Plan:
              </label>
              <select
                id="plan"
                className="w-full border-2 border-gray-300 rounded py-2 px-4"
                value={acDetails.plan}
                onChange={handleChange}
              >
                {availablePlans.map((plan) => (
                  <option key={plan.value} value={plan.value}>
                    {plan.label}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label htmlFor="quantity" className="block font-semibold mb-2">
                Quantity:
              </label>
              <input
                id="quantity"
                type="text" // Allow full editability
                className="w-full border-2 border-gray-300 rounded py-2 px-4"
                value={acDetails.quantity === null ? "" : acDetails.quantity} // Display blank if null
                onChange={handleChange}
                onBlur={handleBlur} // Validate when losing focus
              />
            </div>
            <div>
              <label
                htmlFor="subscription_plan"
                className="block font-semibold mb-2"
              >
                {`Subscription for ${
                  acDetails.plan === "3+2year" || acDetails.plan === "3+3year"
                    ? "M1 to M36"
                    : "M1 to M60"
                } (Per Unit):`}
              </label>
              <input
                type="number"
                id="subscription_plan"
                className="w-full border-2 border-gray-300 rounded py-2 px-4"
                value={acDetails.subscription_plan}
                onChange={handleChange}
                onBlur={handleBlur3}
                readOnly={!isEditableUser}
              />
              {!isEditableUser && (
                <p className="text-xs text-red-500 italic mt-1">
                  Only editable by Admin
                </p>
              )}
            </div>
            <div>
              <label
                htmlFor="installetionCharge"
                className="block font-semibold mb-2"
              >
                Installation Charges (Per Unit):
              </label>
              <input
                type="number"
                id="installetionCharge"
                className="w-full border-2 border-gray-300 rounded py-2 px-4"
                value={acDetails.installetionCharge}
                onChange={handleChange}
                onBlur={handleBlur1}
                readOnly={!isEditableUser}
              />
              {!isEditableUser && (
                <p className="text-xs text-red-500 italic mt-1">
                  Only editable by Admin
                </p>
              )}
            </div>
            <div>
              <label
                htmlFor="depositamount"
                className="block font-semibold mb-2"
              >
                Refundable Deposit (Per Unit):
              </label>
              <input
                type="number"
                id="depositamount"
                className="w-full border-2 border-gray-300 rounded py-2 px-4"
                value={acDetails.depositamount}
                onChange={handleChange}
                onBlur={handleBlur2}
                readOnly={!isEditableUser}
              />
              {!isEditableUser && (
                <p className="text-xs text-red-500 italic mt-1">
                  Only editable by Admin
                </p>
              )}
            </div>

            <div>
              <label
                htmlFor="totalSubscription"
                className="block font-semibold mb-2"
              >
                {`Total Subscription from ${
                  acDetails.plan === "3+2year" || acDetails.plan === "3+3year"
                    ? "M1 to M36"
                    : "M1 to M60"
                }:`}
              </label>
              <input
                type="number"
                id="totalSubscription"
                className="w-full border-2 border-gray-300 rounded py-2 px-4"
                value={acDetails.totalSubscription}
                onChange={handleChange}
                onBlur={handleBlur3}
                readOnly={true}
              />
            </div>
            {/* price per unti */}
            {(acDetails.plan === "3+2year" || acDetails.plan === "3+3year") && (
              <>
                <div>
                  <label
                    htmlFor="priceAfter3Years"
                    className="block font-semibold mb-2"
                  >
                    {`Subscription for ${
                      acDetails.plan === "3+3year" ? "M37 to M72" : "M37 to M60"
                    }(Per unit):`}
                  </label>
                  <input
                    type="number"
                    id="priceAfter3Years"
                    className="w-full border-2 border-gray-300 rounded py-2 px-4"
                    value={acDetails.priceAfter3Years}
                    onChange={handleChange}
                    onBlur={handleBlur4}
                    readOnly={!isEditableUser}
                  />
                </div>
              </>
            )}
            <div>
              <label
                htmlFor="totalInstallation"
                className="block font-semibold mb-2"
              >
                Total Installation Charges:
              </label>
              <input
                type="number"
                id="totalInstallation"
                className="w-full border-2 border-gray-300 rounded py-2 px-4"
                value={acDetails.totalInstallation}
                onChange={handleChange}
                readOnly={true}
              />
            </div>
            <div>
              <label
                htmlFor="totalDeposit"
                className="block font-semibold mb-2"
              >
                Total Refundable Deposit:
              </label>
              <input
                type="number"
                id="totalDeposit"
                className="w-full border-2 border-gray-300 rounded py-2 px-4"
                value={acDetails.totalDeposit}
                onChange={handleChange}
                readOnly
              />
            </div>
            {(acDetails.plan === "3+2year" || acDetails.plan === "3+3year") && (
              <>
                <div>
                  <label
                    htmlFor="totalAfter3Years"
                    className="block font-semibold mb-2"
                  >
                    {`Total Subscription for ${
                      acDetails.plan === "3+3year" ? "M37 to M72" : "M37 to M60"
                    }:`}
                  </label>
                  <input
                    type="number"
                    id="totalAfter3Years"
                    className="w-full border-2 border-gray-300 rounded py-2 px-4"
                    value={acDetails.totalAfter3Years}
                    onChange={handleChange}
                    onBlur={handleBlur4}
                    readOnly
                  />
                </div>
              </>
            )}
            {/* <div className="relative">
              <label htmlFor="approvalcode" className="block font-semibold mb-2">Approval Code</label>
              <input
                type="text"
                id="approvalcode"
                className="w-full border-2 border-gray-300 rounded py-2 px-4 pr-16" // Add padding to the right for the button
                value={acDetails.approvalcode}
                onChange={handleChange}
              />
              <button
                className="absolute right-2 top-1/2  bg-primary text-white rounded py-1 px-4 "
              // Button click handler
              >
                Apply
              </button>
            </div> */}

            <div>
              <label htmlFor="totalAmount" className="block font-semibold mb-2">
                Total Amount to be paid now:
              </label>
              <input
                type="number"
                id="totalAmount"
                className="w-full border-2 border-gray-300 rounded py-2 px-4"
                value={acDetails.totalAmount}
                onChange={handleChange}
                readOnly
              />
            </div>
          </div>
          <div>
            <button
              onClick={editModalACDetails ? handleSaveEdit : handleSave}
              className="mt-4 bg-primary text-white font-normal py-2 px-4 rounded"
            >
              Save AC Details
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
